import { useDispatch } from "react-redux";
import { useHttp } from "./useHttp";
import { createSetRentalAction } from "../actions/dataActions";

export const useRentalData = (id, dataFresh) => {
  let nofetch = !id;
  const dispatch = useDispatch();
  const [data, loading, error] = useHttp(
    `rentals/${id}`,
    "get",
    {},
    dataFresh,
    nofetch
  );
  if (error) {
    throw Error("There was an error");
  }
  if (!loading && data !== null) {
    dispatch(createSetRentalAction(data));
  } else {
    dispatch(
      createSetRentalAction({
        vehicle: {},
        comments: "",
        customer: {},
        invoice_interval: "NONE",
        excess_mileage_cost: 0,
        days: 0,
        short_term_total: 0,
        long_term_total: 0,
        apply_day1_2_rate: true,
        apply_day3_6_rate: true,
        apply_day7_27_rate: true,
        apply_day_28_plus_rate: true,
        apply_insurance: true,
        apply_admin_fee: true,
        off_hire_total_additional_charges: 0,
        day1_2_discount: 0,
        day_3_6_discount: 0,
        day_7_27_discount: 0,
        day_28_plus_discount: 0,
        invoices: [],
        cash_sale: [],
        linked_quotes: [],
        quotes: []
      })
    );
  }
  return !loading;
};
